var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1431 5109 c-172 -34 -333 -185 -388 -364 -17 -57 -18 -151 -18 -2185 0 -2034 1 -2128 18 -2185 57 -184 216 -331 396 -365 73 -14 2169 -14 2242 0 180 34 339 181 396 365 17 57 18 151 18 2185 0 2034 -1 2128 -18 2185 -57 184 -216 331 -396 365 -67 12 -2186 12 -2250 -1z m2267 -275 c28 -14 65 -43 82 -64 64 -81 60 83 60 -2210 0 -2293 4 -2129 -60 -2210 -17 -21 -54 -50 -82 -64 l-52 -26 -1086 0 -1086 0 -52 26 c-28 14 -65 43 -82 64 -64 81 -60 -83 -60 2210 0 2293 -4 2129 60 2210 17 21 54 50 82 64 l52 26 1086 0 1086 0 52 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2024 4671 c-31 -19 -64 -74 -64 -106 0 -32 33 -87 64 -106 64 -39 147 -14 179 54 21 43 21 58 3 102 -28 67 -118 95 -182 56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2447 4669 c-57 -43 -72 -109 -37 -166 37 -61 49 -63 367 -63 264 0 291 2 319 19 31 19 64 74 64 106 0 32 -33 87 -64 106 -29 17 -55 19 -326 19 -283 -1 -296 -2 -323 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2491 929 c-111 -34 -183 -132 -183 -249 0 -101 52 -181 147 -226 96 -46 217 -22 292 57 87 92 87 242 1 344 -54 63 -177 99 -257 74z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.258fd4656aa00d85ce7524ecba2b8246.svg";
export { ForwardRef as ReactComponent };